import React, { useMemo, useRef, useState, useContext } from "react";
import { UserContext } from "../../../../../../context/user/userContext";
import { useEffect } from "react";
import { v4 as uuidv4 } from "uuid"; // or use crypto.randomUUID() in modern browsers
import { BOTAPIError } from "../../../../../../utils/apiErrors";
import { handleApiError } from "../../../../../../utils/globalErrorHandler";
import { getSkillStoreData } from "../../../../skillStore/services/skillStoreService";
import loaderContext from "../../../../../../context/loader/loaderContext";
import AppImages from "../../../../../../constants/images";
import ChatPrompt from "../chatBox/chatPrompt";
import { clearPromptMessageSession } from "../../../../../../services/commonService";
import { useUserName } from "../../../../../common/customHooks/useUserName";
import { json, useLocation, useNavigate } from "react-router-dom";
import ChatHistory from "../chatHistory";
import axios from "axios";
import FileChatbot from "./fileChatbot";
import TextChatbot from "./textChatbot";
import { useHeaderContext } from "../../../../../../context/user/headerContext";
import { getDefaultChatbotConfig } from "../../../../shared/defaultChatBotConfig/defaultConfigService";
import PdfURLContext from "../../../../../../context/pdfURL/pdfURLContext";
import { extractAndRemoveFollowUps } from "../../../../../../services/commonService";
import { isGivenTokenExpired } from "../../../../../../services/tokenService";
import {
  filterTopMessages,
  filterTopMessagesV2,
} from "../../../../promptManagement/shared/promptConverter";
import { saveHistory } from "../../../services/chatHistory";
import { getHistoryChat } from "../../../services/chatHistory";
import showMessage from "../../../../../common/message";
import { useConfig } from "../../../../../../context/config/configContext";

const ChatBox = ({
  modelData,
  selectedModelId,
  selectedModelName,
  isMKSChat,
  chatMessage,
  setIsSkillChat,
  defaultSkillWelMessage,
  setDefaultSkillWelMessage,
  setIsClearChat,
  isClearChat,
  isChatVisible,
  showHideClearChatBtn,
  openPdfViewer,
  setOpenPdfViewer,
  setIsFileTypeChat,
  isFileTypeChat,
  isMKSProcessing,
  setIsMKSProcessing,
  isSkillProcessing,
  setIsSkillProcessing,
  setDisableRegenerateButton,
  setDisableStopGenerateButton,
  disableRegenerateButton,
  disableStopGenerateButton,
  showFollowupQuestion,
  setDisableFolloupButton,
  setShowFollowupQuestion,
  disableFolloupButton,
  setSelectedSkill,
  setIsMessageTyping,
  isMessageTyping,
  isAllowedMessageStreaming,
  matchedSkill,
  skillData
}) => {
  const { state, setIsUserLoggedOut } = useContext(UserContext);
  const { config } = useConfig();
  const [isLinkClicked, setIsLinkClicked] = useState(false);
  const [isAdditiveExpanded, setIsAdditiveExpanded] = useState(false);
  const userId = state?.user?.userProfile?.user_id;
  const userEmail = state?.user?.userProfile?.userName;
  const [location, setLocation] = useState({ lat: null, long: null });
  const { updateLoaderStatus } = useContext(loaderContext);
  const [messages, setMessages] = useState([]);
  const [isTyping, setIsTyping] = useState(false);
  const [lastDisplayMessage, setLastDisplayMessage] = useState("");
  const { initials, fullName } = useUserName();
  const bottomPanelRef = useRef(null);
  const [isRunning, setIsRunning] = useState(false);
  const intervalRef = useRef(null);
  const [currentMessage, setCurrentMessage] = useState("");
  const [showChatLoader, setShowChatLoader] = useState(false);
  bottomPanelRef.current?.scrollIntoView({ behavior: "smooth" });
  const [runningIndex, setRunningIndex] = useState(0);
  const [fileName, setFileName] = useState("");
  const { state: stateNav } = useLocation();
  const [skill, setSkill] = useState(null);
  const [promptText, setPromptText] = useState(stateNav?.promptText);
  const [navigateFromHome, setNavigateFromHome] = useState(
    stateNav?.navigateFromHome
  );
  const { url, setUrl, showTab, setShowTab } = useContext(PdfURLContext);
  const [displayLastCitations, setDisplayLastCitations] = useState([]);
  const [selectedAdditives, setSelectedAdditives] = useState([]);
  const [uploadedFilesFromChat, setUploadedFilesFromChat] = useState([]);
  const [clearUploadedFile, setClearUploadedFile] = useState(false);
  const [selectedCitation, setSelectedCitation] = useState([]);
  const [typingMessage, setTypingMessage] = useState("");
  const { setHeaderState } = useHeaderContext();
  const [resetAdditives, setResetAdditives] = useState(false);
  const [mksDefaultConfiguration, setMksDefaultConfiguration] = useState();
  const [mksUserMessages, setMksUserMessages] = useState([]);
  const [genericAPIUserMessages, setGenericAPIUserMessages] = useState([]);
  const [resumeCitations, setResumeCitations] = useState([]);
  const [uploadedFileDetails, setUploadedFileDetails] = useState([]);
  const [isBlackBoxAdded, setIsBlackBoxAdded] = useState(false);
  const [isTranslateAdded, setIsTranslateAdded] = useState(false);
  const [blackBoxAdditives, setBlackBoxAdditives] = useState("");
  const [init, setInit] = useState(false);
  const [ASSISTANT, TOOL, ERROR] = ["assistant", "tool", "error"];
  const [lastDisplayFileMessage, setLastDisplayFileMessage] = useState([]);
  const [pdfClass, setPdfClass] = useState("");
  const [skills, setSkills] = useState([]);
  const [isHybridChat, setIsHybridChat] = useState(false);
  let userMessageDummy = {};
  let tempImageArray = { name: "", image: "" };
  const [lastImageArray, setLastImageArray] = useState([]);
  const navigate = useNavigate();
  const [expandChecks, setExpandChecks] = useState(false);
  const [isReplyFromBot, setIsReplyFromBot] = useState(false);

  useEffect(() => {
    if (!navigator.geolocation) {
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        setLocation({
          lat: position.coords.latitude,
          long: position.coords.longitude,
        });
      },
      (err) => { }
    );
  }, []);

  useEffect(() => {
    if (matchedSkill) {
      setDefaultSkillWelMessage(false);
      setSkill(matchedSkill);
      matchedSkill?.ChatbotConfiguration?.ChatbotUIView?.toLowerCase() === "additives"
        ? setIsSkillChat(true)
        : setIsSkillChat(false);

      const inputType = matchedSkill?.ChatbotConfiguration?.InputType?.toLowerCase();

      switch (inputType) {
        case "file":
          setIsFileTypeChat(true);
          setIsHybridChat(false);
          break;
        case "file,text":
        case "text,file":
          setIsFileTypeChat(false);
          setIsHybridChat(true);
          break;
        default:
          setIsFileTypeChat(false);
          setIsHybridChat(false);
          break;
      }

      setOpenPdfViewer(false);
      setMessages([]);

      setGenericAPIUserMessages([]);
    }
  }, [matchedSkill]);


  useEffect(() => {
    setMessages([]);
    if (isMKSChat) {
      // if (!matchedSkill)
      //   setSkill(null);
      setHeaderState({
        headerValue: "",
        ShortDescription: "",
      });
      getDefaultChatbotConfig().then((data) => {
        setMksDefaultConfiguration(data);
      });
      setDisableRegenerateButton(true);
      setDisableStopGenerateButton(true);
    }
  }, [isMKSChat]);

  const [conversationId, setConversationId] = useState(null);
  const [conversationShortName, setConversationShortName] = useState("");

  useEffect(() => {
    if (!isMKSChat && skill !== null && skill !== undefined) {
      setHeaderState({
        headerValue: "",
        ShortDescription: "",
      });
      setPdfClass(true);
      setIsLinkClicked(false);
      setExpandChecks(false);
      setIsAdditiveExpanded(false);
      setIsReplyFromBot(false);
    }

    setShowFollowupQuestion(skill?.ChatbotConfiguration?.ShowFollowUpQuestions);
    setDisableFolloupButton(
      skill?.ChatbotConfiguration?.DisableFollowUpQuestions
    );
    setSelectedSkill(skill);
    setDisableRegenerateButton(true);
    setDisableStopGenerateButton(true);

    let isUseSkillOfMarcom = false;
    if (skill?.Id) {
      const inputType = skill?.ChatbotConfiguration?.InputType?.toLowerCase();

      switch (inputType) {
        case "file":
          setIsFileTypeChat(true);
          setIsHybridChat(false);
          break;
        case "file,text":
        case "text,file":
          setIsFileTypeChat(false);
          setIsHybridChat(true);
          isUseSkillOfMarcom = true;
          break;
        default:
          setIsFileTypeChat(false);
          setIsHybridChat(false);
          break;
      }

      const history = JSON.parse(
        localStorage.getItem("conversationHistory") || "[]"
      );

      const existingIndex = history?.findIndex(
        (item) => item.skillId === skill.Id
      );

      if (existingIndex >= 0) {
        const updatedConversation = history[existingIndex];

        setConversationId(updatedConversation.conversationId);
        // Set the short name from storage if it exists
        setConversationShortName(
          updatedConversation.conversationShortName || ""
        );

        const historyResult = history.filter(
          (item) => item.skillId === skill.Id
        );
        if (historyResult[0].conversationShortName !== "") {
          let item = {
            user_Id: userId,
            conversationId: historyResult[0].conversationId,
          };
          handleChatHistoryRowClick(item, isUseSkillOfMarcom);
        }
      } else {
        // Create new conversation
        const newConversation = {
          conversationId: uuidv4(),
          skillId: skill.Id,
          timestamp: new Date().toISOString(),
          conversationShortName: "", // Start with empty name
        };

        // Update history and state
        const updatedHistory = [...history, newConversation];
        localStorage.setItem(
          "conversationHistory",
          JSON.stringify(updatedHistory)
        );

        localStorage.setItem(
          "currentConversation",
          JSON.stringify(newConversation)
        );

        setConversationId(newConversation.conversationId);
        setConversationShortName(""); // Initialize as empty
      }
    }
  }, [skill]);

  const updateConversationShortName = (skill, inputText) => {
    const newShortName = getConversationShortName(skill, inputText);

    // Update React state immediately
    setConversationShortName(newShortName);

    const currentConversation = JSON.parse(
      localStorage.getItem("currentConversation") || "{}"
    );

    const history = JSON.parse(
      localStorage.getItem("conversationHistory") || "[]"
    );

    if (currentConversation?.conversationId) {
      const updatedConversation = {
        ...currentConversation,
        conversationShortName: newShortName,
      };

      localStorage.setItem(
        "currentConversation",
        JSON.stringify(updatedConversation)
      );

      const updatedHistory = history.map((item) =>
        item.conversationId === currentConversation.conversationId
          ? updatedConversation
          : item
      );
      localStorage.setItem(
        "conversationHistory",
        JSON.stringify(updatedHistory)
      );
    }

    return newShortName;
  };

  //function added here by priyanshu
  const handleNewchat = () => {
    const newConversationId = uuidv4();
    const newTimestamp = new Date().toISOString();
    const newConversationShortName = ""; // Modify if needed

    const history = JSON.parse(
      localStorage.getItem("conversationHistory") || "[]"
    );

    const newConversation = {
      conversationId: newConversationId,
      skillId: skill?.Id, // Ensure skill is defined
      timestamp: newTimestamp,
      conversationShortName: newConversationShortName,
    };

    const updatedHistory = history?.filter(
      (item) => item.skillId !== skill?.Id
    ); // Remove old conversation with same skill ID
    updatedHistory.push(newConversation);

    localStorage.setItem("conversationHistory", JSON.stringify(updatedHistory));
    localStorage.setItem(
      "currentConversation",
      JSON.stringify(newConversation)
    );

    setConversationId(newConversationId);
    setConversationShortName(newConversationShortName);
    setSelectedSkill({ ...skill }); // Ensure effect triggers
  };

  useEffect(() => {
    if (isClearChat) {
      if (isMKSChat) {
        clearMKSData();
      } else {
        clearSKILLData();
      }
      setMessages([]);
      setGenericAPIUserMessages([]);
      handleNewchat(); //changes made here by priyanshu
    }
    setIsClearChat(false);
  }, [isClearChat]);

  useEffect(() => {
    if (bottomPanelRef.current && isMessageTyping) {
      bottomPanelRef.current.scrollIntoView({ behavior: "smooth" });
    }
  }, [typingMessage, isMessageTyping]);

  useEffect(() => {
    if (bottomPanelRef.current) {
      bottomPanelRef.current.scrollIntoView({ behavior: "smooth" });
    }
    showHideClearChatBtn(messages?.length === 0 ? false : true);
    if (
      messages?.length > 0 &&
      !isMKSChat &&
      skill !== null &&
      skill !== undefined
    ) {
      setHeaderState({
        headerValue: skill.Name,
        ShortDescription: skill.ShortDescription,
      });
    } else if (messages?.length > 0 && isMKSChat) {
      setHeaderState({
        headerValue: "MKS Chat",
        ShortDescription: "",
      });
    } else if (messages?.length === 0) {
      setHeaderState({
        headerValue: "",
        ShortDescription: "",
      });
    }
  }, [messages]);

  useEffect(() => {
    setSkills(skillData);
  }, [skillData]);

  // const getAllSkills = async () => {
  //   await getSkillStoreData().then((res) => {
  //     if (res !== null && res !== undefined)
  //       res = res.filter((item) => item.IsThirdPartyAITool === false);
  //     setSkills(res);
  //   });
  // };

  const handleChatHistoryRowClick = async (item, isUseSkillOfMarcom) => {
    try {
      setIsReplyFromBot(false);
      updateLoaderStatus(true);
      const response = await getHistoryChat(item.user_Id, item.conversationId);

      if (isHybridChat || isUseSkillOfMarcom) {
        let transformedMessages = [];
        setMessages([]);
        const chatHistory = response.response || [];

        const firstItem = chatHistory[0];
        setFirstDefaultConversation(firstItem);

        for (let i = 0; i < chatHistory.length; i++) {
          const msg = chatHistory[i];

          if (
            msg.role === "user" &&
            Array.isArray(msg.files) &&
            msg.files.length > 0
          ) {
            for (let j = 0; j < msg.files.length; j++) {
              const fileUrl = msg.files[j]; // Get each file URL

              try {
                const base64Response = await getFileAsBase64(fileUrl);
                const urlParts = fileUrl.split("/");
                const encodedFileName = urlParts[urlParts.length - 1];
                const fileName = decodeURIComponent(encodedFileName);
                const newFile = base64ToFile(base64Response, fileName);
                msg.files[j] = newFile;
              } catch (fileError) {
                console.error(
                  `Failed to process file for message index ${i}, file index ${j}:`,
                  fileError
                );
              }
            }
          }

          let messageText = msg.chatText || "";
          if (
            msg.role === "assistant" &&
            Array.isArray(msg.images) &&
            msg.images.length > 0
          ) {
            for (let j = 0; j < msg.images.length; j++) {
              const fileUrl = msg.images[j];

              try {
                const base64Response = await getFileAsBase64(fileUrl);
                const urlParts = fileUrl.split("/");
                const encodedFileName = urlParts[urlParts.length - 1];
                const imageName = decodeURIComponent(encodedFileName);
                const tempImageArray = {
                  name: imageName,
                  image: base64Response,
                };

                if (!Array.isArray(msg.files)) {
                  msg.files = [];
                }

                msg.files.push(tempImageArray);
                if (i === chatHistory.length - 1) {
                  setLastImageArray([tempImageArray]);
                }

                setLastDisplayMessage(
                  i === chatHistory.length - 1
                    ? `![${imageName}](placeholder)`
                    : []
                );
                messageText = messageText
                  ? `${messageText}\n![${imageName}](placeholder)`
                  : `![${imageName}](placeholder)`;
              } catch (fileError) {
                console.error(
                  `Failed to process assistant file at message ${i}, file ${j}:`,
                  fileError
                );
              }
            }
          }

          const matchedSkill = skills?.find(
            (skill) => skill?.Id === msg?.skillId
          ) || { Name: "" };
          const message = {
            text:
              msg.role?.toLowerCase() === "user"
                ? msg?.originalChatText
                : messageText,
            type: msg.role?.toLowerCase() === "user" ? "user" : "reply",
            imageURL:
              msg.role?.toLowerCase() === "user"
                ? AppImages.profilePic
                : AppImages.chatAIIcon,
            citations: msg.citations || [],
            chatType: isMKSChat,
            skill: matchedSkill.Name,
            isErrorOccured: msg.isFailed || false,
            files: msg.files,
            followupQuestion: msg.followupQuestion || [],
          };

          transformedMessages.push(message);
          setLastDisplayMessage(
            transformedMessages[transformedMessages.length - 1].text
          );
          setMessages(transformedMessages);
        }
      } else {
        const chatHistory = response.response || [];

        const firstItem = chatHistory[0];
        setFirstDefaultConversation(firstItem);
        setMessages([]);
        setGenericAPIUserMessages([]);

        const transformedMessages = (response.response || []).map((msg) => {
          const matchedSkill = skills?.find(
            (skill) => skill?.Id === msg?.skillId
          );

          return {
            text: msg.chatText,
            type: msg.role.toLowerCase(),
            imageURL:
              msg.role.toLowerCase() === "user"
                ? AppImages.profilePic
                : AppImages.chatAIIcon,
            citations: msg.citations || [],
            chatType: false,
            skill: matchedSkill?.Name || "", // fallback to empty string if not found
            isErrorOccured: msg.isFailed,
          };
        });

        setGenericAPIUserMessages(
          getGenericMessageContext(transformedMessages)
        );
        setLastDisplayMessage(
          transformedMessages[transformedMessages.length - 1].text
        );
        setDisplayLastCitations(
          transformedMessages[transformedMessages.length - 1].citations
        );
        setMessages(transformedMessages);
      }
    } catch (error) {
      console.error("Error fetching chat history:", error);
    } finally {
      updateLoaderStatus(false);
    }
  };

  const setFirstDefaultConversation = (firstItem) => {
    const conversationId = firstItem?.conversationId || "";
    const conversationShortName = firstItem?.conversationShortName || "";
    setConversationId(conversationId);
    setConversationShortName(conversationShortName);

    let updatedHistoryEntry = {
      conversationId: conversationId,
      conversationShortName: conversationShortName,
      skillId: firstItem?.skillId,
    };

    let existingHistory =
      JSON.parse(localStorage.getItem("conversationHistory")) || [];

    existingHistory = existingHistory.filter(
      (entry) => entry.skillId !== updatedHistoryEntry.skillId
    );

    const updatedHistory = [updatedHistoryEntry, ...existingHistory];

    localStorage.setItem("conversationHistory", JSON.stringify(updatedHistory));
  };

  async function getFileAsBase64(fileUrl) {
    // const base64SignedUrl = `${fileUrl}${skill?.ChatbotConfiguration?.ImageParams ||
    //   process.env.REACT_APP_IMAGE_CHATBOT_API
    //   }`;
    const imageParams =
        skill?.ChatbotConfiguration?.ImageParams ||
        config.REACT_APP_IMAGE_CHATBOT_API ||
        "";
    const base64SignedUrl = `${fileUrl}${imageParams}`;
    const response = await fetch(base64SignedUrl);
    if (!response.ok) throw new Error("Failed to fetch base64 data.");
    const blob = await response.blob();
    return await blobToBase64(blob);
  }

  function blobToBase64(blob) {
    return new Promise((resolve, reject) => {
      const reader = new FileReader();
      reader.onloadend = () => resolve(reader.result); // This is base64 with prefix
      reader.onerror = reject;
      reader.readAsDataURL(blob); // Converts blob to base64 with MIME prefix
    });
  }

  function base64ToFile(base64, filename) {
    const arr = base64.split(",");
    const mime = arr[0].match(/:(.*?);/)[1];
    const bstr = atob(arr[1]);
    let n = bstr.length;
    const u8arr = new Uint8Array(n);

    while (n--) {
      u8arr[n] = bstr.charCodeAt(n);
    }

    return new File([u8arr], filename, { type: mime });
  }

  const getGenericMessageContext = (transformedMessages) => {
    return filterTopMessagesV2(
      [],
      parseInt(skill.lastMessageCount == null ? 0 : skill.lastMessageCount),
      transformedMessages,
      skill.AssistantMessageFormat,
      skill.userMessage
    );
  };

  const handleExceptionResponse = () => {
    setIsSkillProcessing(false);
    setIsMKSProcessing(false);
    setShowChatLoader(false);
  };

  const updateSetMessages = () => {
    setMessages((prevMessages) => {
      const lastLoaderIndex = [...prevMessages]
        .reverse()
        .findIndex((msg) => msg.type === "reply" && msg.text === "loader");

      const actualLoaderIndex =
        lastLoaderIndex !== -1 ? prevMessages.length - 1 - lastLoaderIndex : -1;

      const lastUserIndex = [...prevMessages]
        .reverse()
        .findIndex((msg) => msg.type === "user");

      const actualUserIndex =
        lastUserIndex !== -1 ? prevMessages.length - 1 - lastUserIndex : -1;

      const updatedMessages = [...prevMessages];

      if (actualLoaderIndex !== -1) {
        updatedMessages.splice(actualLoaderIndex, 1);
      }

      if (actualUserIndex !== -1) {
        updatedMessages[actualUserIndex] = {
          ...updatedMessages[actualUserIndex],
          isErrorOccured: true,
        };
      }

      return updatedMessages;
    });
  };

  const handleExceptionAndMessages = () => {
    setShowChatLoader(false);
    updateSetMessages();
    setIsSkillProcessing(false);
    setIsMKSProcessing(false);
    handleApiError(new BOTAPIError(skill?.Name)); // Wrap in BOTAPIError
  };

  const setMessageToSession = (value) => {
    let localMessage = localStorage.getItem("messages") || "";
    if (localMessage === "") {
      localMessage = [];
    } else {
      localMessage = JSON.parse(localMessage);
    }

    localMessage.push(value);
    localStorage.setItem("messages", JSON.stringify(localMessage));
  };

  const clearMKSData = () => {
    try {
      let localMessage = localStorage.getItem("messages");
      if (!localMessage) {
        localMessage = []; // Default to an empty array if no messages exist
      } else {
        localMessage = JSON.parse(localMessage); // Parse the JSON string
      }

      if (Array.isArray(localMessage) && localMessage.length > 0) {
        const data = localMessage.filter((item) => !item.chatType);

        clearPromptMessageSession();
        localStorage.setItem("messages", JSON.stringify(data));
      }
    } catch (error) {
      console.error("Error in clearMKSData:", error);
    }
  };

  const clearSKILLData = () => {
    try {
      let localMessage = localStorage.getItem("messages");
      if (!localMessage) {
        localMessage = []; // Default to an empty array if no messages exist
      } else {
        localMessage = JSON.parse(localMessage); // Parse the JSON string
      }

      if (Array.isArray(localMessage) && localMessage.length > 0) {
        const data = localMessage.filter((item) => item.skill !== skill?.Name);
        clearPromptMessageSession();

        localStorage.setItem("messages", JSON.stringify(data));
      }
    } catch (error) {
      console.error("Error in clearMKSData:", error);
    }
  };

  const handleAIHybridGenericResponse = async (inputText) => {
    setDisableStopGenerateButton(true);
    setDisableRegenerateButton(true);
    setShowChatLoader(true);
    setLastDisplayMessage("");
    setDisplayLastCitations([]);
    setLastImageArray([]);
    const uploadedFiles = await handleFileSelection();
    const date = new Date();
    const userUtcDate = date.toISOString();

    let finalShortName = conversationShortName;
    if (!finalShortName) {
      finalShortName = updateConversationShortName(skill, inputText);
    }

    const conversationInfo = {
      conversationId: conversationId,
      conversationShortName: finalShortName, //getConversationShortName(skill, inputText),
      conversationDateTime: userUtcDate,
      user_Id: userId,
      lat: location.lat,
      long: location.long,
      skill_store_id: skill?.Id,
      user_message: inputText,
      userEmail: userEmail,
      ModelName: selectedModelName,
      ModelId: selectedModelId === "0" || selectedModelId === 0 ? "default" : selectedModelId,
    };

    const userMessage = {
      text: inputText,
      type: "user",
      files: uploadedFilesFromChat,
      imageURL: AppImages.profilePic,
      citations: [],
      chatType: isMKSChat,
      skill: skill?.Name,
      isErrorOccured: false,
    };
    setMessages((prev) => [...prev, userMessage]);

    const formData = buildFormDataForUpload(
      uploadedFiles.map((f) => f.fileObject),
      conversationInfo
    );
    const wrapperUrl = skill.IsUsingWrapperAPIURL
      ? skill.WrapperAPIURL
      : process.env.REACT_APP_CHAT_WRAPPER_HYBRID_URL;

    const aiResponse = {
      text: "loader",
      type: "reply",
      files: null,
      imageURL: AppImages.chatAIIcon,
      citations: [],
      chatType: isMKSChat,
      skill: skill?.Name,
    };

    setMessages((prev) => [...prev, aiResponse]);
    try {
      const responseA = await fetch(wrapperUrl, {
        method: skill.method,
        headers: {
          Authorization: "Bearer " + localStorage.getItem("token"),
        },
        body: formData,
      });
      if (!responseA.ok || !responseA.body) {
        if (
          responseA.status === 500 &&
          isGivenTokenExpired(localStorage.getItem("token"))
        ) {
          showMessage(
            "Session timed out, you will be redirected to login screen.",
            -2
          );
          setTimeout(() => {
            setIsUserLoggedOut(true);
            navigate("/login");
          }, 3000);
          return;
        }
        if (responseA.status === 500 || responseA.status === 400) {
          const responseString = await responseA?.text();
          const contains429 =
            responseString.includes("'code': '429'") ||
            responseString.includes("status 429") ||
            responseString.includes("RateLimitError");
          if (contains429) {
            showMessage(
              "The system has reached its allowed usage quota (tokens per minute).Please wait a few minutes and try again. If you need immediate assistance, contact the support team.",
              -2
            );
            resetControls();
            return;
          } else {
            handleExceptionAndMessages();
            return;
          }
        }
      }
      const result = await responseA.json();
      if (result?.error) {
        handleExceptionAndMessages();
      } else if (result?.image) {
        try {
         // const url =
          //   result?.image + skill?.ChatbotConfiguration?.ImageParams ||
          //   process.env.REACT_APP_IMAGE_CHATBOT_API;
          const imageParams =
            skill?.ChatbotConfiguration?.ImageParams ||
            config.REACT_APP_IMAGE_CHATBOT_API ||
            "";
          const url = result?.image + imageParams;
          const imageName = result?.image.split("/").pop();
          const response = await fetch(url);
          const blob = await response.blob();

          const reader = new FileReader();
          reader.readAsDataURL(blob);
          setIsReplyFromBot(true);
          reader.onload = () => {
            const base64String = reader.result.replace(
              /^data:.*;base64,/,
              "data:image/png;base64,"
            );
            const tempImageArray = {
              name: imageName,
              image: base64String,
            };
            setLastImageArray([tempImageArray]);
            const botMessage = {
              text: `![${imageName}](placeholder)`,
              files: [tempImageArray],
              type: "reply",
              imageURL: AppImages.chatAIIcon,
              citations: [],
              chatType: isMKSChat,
              skill: skill?.Name,
            };
            setMessages((prev) => [
              ...prev.filter((p) => p.text !== "loader"),
              botMessage,
            ]);
            setLastDisplayMessage(`![${imageName}](placeholder)`);
          };
        } catch (error) {
          handleExceptionAndMessages();
        }
      } else if (result?.text) {
        setIsReplyFromBot(true);
        const botMessage = {
          text: result.text,
          files: null,
          type: "reply",
          imageURL: AppImages.chatAIIcon,
          citations: [],
          chatType: isMKSChat,
          skill: skill?.Name,
        };
        setMessages((prev) => [
          ...prev.filter((p) => p.text !== "loader"),
          botMessage,
        ]);
        setLastDisplayMessage(result.text);
      } else {
        handleExceptionAndMessages();
      }
    } catch (error) {
      handleExceptionAndMessages();
    }
  };

  const handleAIGenericResponse = async (inputText) => {
    if (!isMKSChat) {
      setPdfClass(true);
      setIsLinkClicked(false);
      // setExpandChecks(false);
      // setIsAdditiveExpanded(false);
      const showFollowUpQuestions =
        skill?.ChatbotConfiguration?.ShowFollowUpQuestions;
      if (isHybridChat) {
        handleAIHybridGenericResponse(inputText);
        setUploadedFilesFromChat([]);
      } else {
        if (
          skill?.ChatbotConfiguration?.FileType === null ||
          skill?.ChatbotConfiguration?.FileType === ""
        ) {
          const isNewFlag = process.env.REACT_APP_CHAT_FLAG_SKILLAPI;
          if (isNewFlag === "true") {
            handleLoadGenericApiConfigurationsV2(
              inputText,
              showFollowUpQuestions
            );
          } else {
            handleLoadGenericApiConfigurations(
              inputText,
              showFollowUpQuestions
            );
          }
        } else if (isFileTypeChat) {
          handleFileUploadApiConfigurations(inputText);
        }
      }
    } else {
      const isNewFlag = process.env.REACT_APP_CHAT_FLAG_MKS_NEW;
      if (isNewFlag === "true") {
        handleMksAIWrapperResponse(inputText);
      } else {
        handleMksAIResponse(inputText);
      }
    }
  };

  const convertCollectionData = (collection) => {
    if (collection[0].length !== undefined) {
      return collection[0]
        .map((item) => `${item.Value}=${item.checked}`)
        .join("&");
    } else {
      return collection
        .map((item) => `${item.Value}=${item.checked}`)
        .join("&");
    }
  };

  const removeSpecialCharacters = (text) => {
    const containsSpecialCharacters = /[^a-zA-Z0-9 ]/g;
    const containsEnglish = /[a-zA-Z]/g;

    if (containsEnglish.test(text) && containsSpecialCharacters.test(text)) {
      return text.replace(/[^a-zA-Z0-9 ]/g, "");
    }
    return text;
  };
  const handleFileUploadApiConfigurations = async () => {
    try {
      let uploadedContent = [];
      let citations = [];
      let response = "";
      if (isGivenTokenExpired(localStorage.getItem("token"))) {
        showMessage(
          "Session timed out, you will be redirected to login screen.",
          -2
        );
        setTimeout(() => {
          setIsUserLoggedOut(true);
          navigate("/login");
        }, 3000);
        return;
      }
      setUploadedFileDetails([]);
      let errorCounter = 1;

      let additivess = selectedAdditives.filter(
        (item) => item.Name !== "Translate"
      );

      const isTranslateAdded = selectedAdditives.filter(
        (item) => item.Name === "Translate"
      )[0].checked;
      setIsTranslateAdded(isTranslateAdded);

      const selectedAdditivesArray = additivess.map((item) => item.Value);

      setIsSkillProcessing(true);
      setIsMKSProcessing(false);

      let blackBox = selectedAdditives.filter(
        (item) => item.Name === "Blackbox"
      )[0];
      let blackBoxAdded = false;
      if (blackBox.checked) {
        blackBoxAdded = true;
        setIsBlackBoxAdded(true);
      } else {
        blackBoxAdded = false;
        setIsBlackBoxAdded(false);
      }
      setShowChatLoader(true);
      const userMessage = {
        text: "",
        type: "user",
        imageURL: AppImages.profilePic,
        citations: [],
        files: uploadedFilesFromChat,
        skill: skill?.Name,
        isErrorOccured: false,
      };

      setMessages((prev) => [...prev, userMessage]);

      const aiResponse = {
        text: "loader",
        type: "reply",
        imageURL: AppImages.chatAIIcon,
        citations: [],
        file: [],
      };
      setMessages((prev) => [...prev, aiResponse]);

      setBlackBoxAdditives("");
      let counter = 0;
      setLastDisplayFileMessage([]);
      let uploadedAllFiles = [];
      setClearUploadedFile(true);

      uploadedFilesFromChat.forEach(async (file) => {
        const queryString = convertCollectionData(selectedAdditives);
        let url = skill.aiUrl.replace("$additives", queryString);
        setShowChatLoader(true);
        setDisplayLastCitations([]);
        setIsTyping(true);
        const FormData = require("form-data");

        let data = new FormData();
        data.append("file", file);

        let config = {
          method: "post",
          maxBodyLength: Infinity,
          url: removeTrailingSlash(url),
          headers: skill.headers,
          data: data,
        };

        const axiosApiInstance = axios.create();

        const uploadFile = async () => {
          try {
            const resp = await axiosApiInstance.post(config.url, data, config);

            uploadedContent.push(resp.data);
            setIsSkillProcessing(true);
            uploadedAllFiles.push({
              fileName: file.name,
              jsonOutPut: JSON.stringify(resp.data),
              selectedAdditivesArray: selectedAdditivesArray,
              isBlackBoxAdded: blackBoxAdded,
              isTranslateAdded: isTranslateAdded,
            });

            counter = counter + 1;

            if (uploadedContent.length === uploadedFilesFromChat.length) {
              response = JSON.stringify(uploadedContent).toString();
              createBotMessage(
                response,
                citations,
                uploadedFilesFromChat,
                skill,
                uploadedAllFiles,
                selectedAdditivesArray,
                blackBoxAdded,
                isTranslateAdded
              );
              setLastDisplayFileMessage(uploadedAllFiles);
              setBlackBoxAdditives(response);
              setShowChatLoader(false);
              setUploadedFilesFromChat([]);
              setUploadedFileDetails([...uploadedAllFiles]);
              setResetAdditives((prev) => !prev);
              setSelectedAdditives([]);
              setIsTyping(false);
            }
            setClearUploadedFile(true);
          } catch (error) {
            if (errorCounter === 1) {
              setMessages((prev) => {
                let updatedMessages = [...prev];

                if (updatedMessages.length >= 2) {
                  const secondLastIndex = updatedMessages.length - 2;
                  const lastIndex = updatedMessages.length - 1;

                  updatedMessages[secondLastIndex] = {
                    ...updatedMessages[secondLastIndex],
                    isErrorOccured: true,
                  };

                  updatedMessages.splice(lastIndex, 1);
                }

                return updatedMessages;
              });
              handleExceptionResponse();
              handleApiError(new BOTAPIError(skill?.name));
              errorCounter = 0;
            }
          } finally {
            setClearUploadedFile((clearUploadedFile) => !clearUploadedFile);
          }
        };
        uploadFile();
      });
    } catch {
      setIsSkillProcessing(false);
      setIsMKSProcessing(false);
      handleApiError(new BOTAPIError(skill?.name));
    }
  };

  const handleFileSelection = async () => {
    try {
      let fileDetails = [];

      uploadedFilesFromChat.forEach((file) => {
        fileDetails.push({
          fileName: file.name,
          fileType: file.type,
          fileSize: file.size,
          fileObject: file,
        });
      });

      return fileDetails;
    } catch (error) {
      console.error("Error processing selected files", error);
      throw error;
    }
  };

  const buildFormDataForUpload = (files, conversationInfo) => {
    const formData = new FormData();

    files.forEach((file) => {
      formData.append("attachments", file); // Append multiple files with the same key
    });

    formData.append("data", JSON.stringify(conversationInfo));
    return formData;
  };

  const createBotMessage = (
    response,
    citations,
    uploadedFilesFromChat,
    skill,
    uploadedAllFiles,
    selectedAdditivesArray,
    blackBoxAdded,
    isTranslateAdded
  ) => {
    const botMessage = {
      text: response,
      type: "reply",
      imageURL: AppImages.chatAIIcon,
      citations: citations,
      files: uploadedFilesFromChat,
      skill: skill?.Name,
      uploadedFileDetails: uploadedAllFiles,
      selectedAdditivesArray: selectedAdditivesArray,
      isBlackBoxAdded: blackBoxAdded,
      isTranslateAdded: isTranslateAdded,
    };
    setMessageToSession(botMessage);
    setMessages((prev) => [
      ...prev.filter((p) => p.text !== "loader"),
      botMessage,
    ]);
  };

  const handleLoadGenericApiConfigurations = async (
    inputText,
    showFollowUpQuestions
  ) => {
    try {
      if (!inputText?.trim()) {
        return;
      }
      setDisableStopGenerateButton(true);
      setDisableRegenerateButton(true);
      setShowChatLoader(true);
      setLastDisplayMessage("");
      setDisplayLastCitations([]);
      const userMessage = {
        text: inputText,
        type: "user",
        imageURL: AppImages.profilePic,
        citations: [],
        chatType: isMKSChat,
        skill: skill?.Name,
        isErrorOccured: false,
      };
      setMessageToSession(userMessage);
      setMessages((prev) => [...prev, userMessage]);

      let updatedText = removeSpecialCharacters(inputText);
      if (showFollowUpQuestions && disableFolloupButton === false) {
        updatedText = `${updatedText} ${process.env.REACT_APP_FOLLOWUP_QUESTION}`;
      }
      let formatedInputText = updatedText
        .replace(/\n/g, "\\n") // Escape newlines
        .replace(/\r/g, "\\r") // Escape carriage returns
        .replace(/\\/g, "\\\\")
        .replace(/^"|"$/g, "");
      formatedInputText = formatedInputText.replace(
        /"([^"]*?)"(?=\s|[:,}])/g,
        '\\"$1\\"'
      );

      let userMessageData = skill.userMessage.replace(
        "$Message",
        `"${formatedInputText}"`
      );
      let lastMessageCount =
        skill.lastMessageCount == null ? 0 : skill.lastMessageCount;

      let parsedUserMessageData = JSON.parse(userMessageData);

      const finalRequestBody = [];
      let isStreamAPI = true;
      let oldgenericAPIUserMessages = [...genericAPIUserMessages];
      if (lastMessageCount > 0) {
        let previousSentMessages = filterTopMessagesV2(
          genericAPIUserMessages,
          parseInt(lastMessageCount),
          messages,
          skill.AssistantMessageFormat,
          skill.userMessage
        );

        if (genericAPIUserMessages.length > 0) {
          previousSentMessages.forEach((msg) => {
            finalRequestBody.push(msg);

            if (genericAPIUserMessages.length === 0) {
              oldgenericAPIUserMessages.push(msg);
            }
          });
        }
      }

      finalRequestBody.push(parsedUserMessageData);
      let msgs = JSON.stringify(finalRequestBody);
      msgs = msgs.substring(1, msgs.length - 1);

      let userMessageModel2 = skill.messageBody.replace("$UserMessage", msgs);
      oldgenericAPIUserMessages.push(parsedUserMessageData);
      userMessageModel2 = JSON.parse(userMessageModel2);
      isStreamAPI = userMessageModel2.stream;
      userMessageModel2 = JSON.stringify(userMessageModel2);

      const aiResponse = {
        text: "loader",
        type: "reply",
        imageURL: AppImages.chatAIIcon,
        citations: [],
        chatType: isMKSChat,
        skill: skill?.Name,
      };
      setMessages((prev) => [...prev, aiResponse]);
      let response = "";
      try {
        const responseA = await fetch(removeTrailingSlash(skill.aiUrl), {
          method: "post",
          headers: skill.headers,
          body: userMessageModel2,
        });
        if (!responseA.ok || !responseA.body) {
          handleExceptionAndMessages();
          return;
        }
        const reader = responseA.body.getReader();
        const decoder = new TextDecoder("utf-8");
        const loopRunner = true;
        let citations = [];
        while (loopRunner) {
          try {
            const { value, done } = await reader.read();
            if (done) {
              break;
            }
            let decodedChunk = decoder.decode(value, { stream: true });

            let replacedChunk = decodedChunk.replace("data: ", "");
            let findContext =
              replacedChunk.indexOf("context") &&
              replacedChunk.indexOf("citations");
            if (findContext > -1) {
              try {
                citations =
                  JSON.parse(replacedChunk)?.choices[0]?.delta?.context
                    ?.citations;
              } catch (error) { }
            }
            if (isStreamAPI === true) {
              let splitChunk = replacedChunk.split("\n\ndata:").slice(0, -1);
              let datas = JSON.parse(JSON.stringify(splitChunk));
              let counter = 0;
              datas.forEach((da) => {
                let jsonArray = null;
                try {
                  jsonArray = JSON.parse(da);
                  if (jsonArray.choices.length > 0) {
                    const text = jsonArray.choices[0].delta?.content || "";
                    if (counter < 2 && (text.match(/\n/) || []).length) {
                      return;
                    }
                    response = response + text;
                    setIsTyping(true);
                    counter++;
                  }
                } catch (parseError) { }
              });
            } else {
              setIsTyping(false);
              let datas = JSON.parse(replacedChunk);
              citations = datas?.choices[0]?.message?.context?.citations;
              response = datas?.choices[0]?.message?.content;
            }
          } catch (readError) { }
          setShowChatLoader(false);
        }

        let followupText = [];
        if (showFollowUpQuestions && disableFolloupButton === false) {
          const result = extractAndRemoveFollowUps(response);
          response = result.modifiedText;
          followupText = result.followUpQuestions;
        }

        const botMessage = {
          text: response,
          type: "reply",
          imageURL: AppImages.chatAIIcon,
          citations: citations,
          chatType: isMKSChat,
          skill: skill?.Name,
          followupQuestion: followupText,
        };

        let assistantMessageModel = skill.AssistantMessageFormat.replace(
          "$replyMsg",
          `"${response}"`
        );
        let assistantMessage = {};
        try {
          assistantMessage = JSON.parse(assistantMessageModel);
        } catch (error) {
          assistantMessage = JSON.parse(
            skill.AssistantMessageFormat.replace("$replyMsg", `"$"`)
          );
          if (assistantMessage.content[0].type === undefined) {
            assistantMessage.content = response;
            assistantMessage.role = "assistant";
          } else {
            assistantMessage.content[0].text = response;
            assistantMessage.role = "assistant";
          }
        }

        oldgenericAPIUserMessages.push(assistantMessage);
        setGenericAPIUserMessages([...oldgenericAPIUserMessages]);
        setMessageToSession(botMessage);
        setMessages((prev) => [
          ...prev.filter((p) => p.text !== "loader"),
          botMessage,
        ]);
        setLastDisplayMessage("");
        setDisplayLastCitations([]);
        typeText(response, citations);
      } catch (error) {
        handleExceptionAndMessages();
      }
    } catch (ex) {
      console.log(ex);
      handleExceptionAndMessages();
    }
  };

  const [messagesDummy, setMessagesDummy] = useState([]);

  function getConversationShortName(skill, inputText) {
    if (!skill?.Name) return "MKS"; // Handle missing skill

    const genericGreetings = new Set([
      "hi",
      "hello",
      "hey",
      "greetings",
      "good morning",
      "good afternoon",
      "good evening",
    ]);
    const commonWords = new Set([
      "i",
      "need",
      "help",
      "the",
      "a",
      "an",
      "please",
      "can",
      "you",
      "is",
      "to",
      "for",
      "in",
      "on",
      "what",
      "are",
    ]);

    let words = inputText.trim().toLowerCase().split(/\s+/);

    let keyword = words.find((word) => !commonWords.has(word)) || "help";

    let skillWords = skill.Name.trim().split(/\s+/);
    let domain = skillWords[0].toLowerCase(); // First word as domain
    let acronym = skillWords
      .map((word) => word.charAt(0).toLowerCase())
      .join(""); // Acronym from initials

    if (domain.startsWith("chemical")) domain = "chemistry";

    return `${keyword} -${domain} ${acronym}`.trim();
  }

  const setMessageToSessionDummy = (value) => {
    let localMessage = localStorage.getItem("messagesDummy") || "";
    if (localMessage === "") {
      localMessage = [];
    } else {
      localMessage = JSON.parse(localMessage);
    }

    localMessage.push(value);
    localStorage.setItem("messagesDummy", JSON.stringify(localMessage));
  };

  // const resetControls = () => {
  //   setShowChatLoader(false);
  //   updateSetMessages();
  //   setIsSkillProcessing(false);
  //   setIsMKSProcessing(false);
  // };

  const resetControls = () => {
    setShowChatLoader(false);
    updateSetMessages();
    setIsSkillProcessing(false);
    setIsMKSProcessing(false);
  };

  const handleLoadGenericApiConfigurationsV2 = async (
    inputText,
    showFollowUpQuestions
  ) => {
    try {
      if (!inputText?.trim()) {
        return;
      }
      if (modelData && modelData?.length > 0) {
        if (parseInt(selectedModelId) !== NaN) {
          const model = modelData.filter((item) => item.Id === parseInt(selectedModelId))
          if (model?.length > 0) {
            skill.userMessage = model[0].UserAssistantMessageFormat;
          }
        }
      }

      setDisableStopGenerateButton(true);
      setDisableRegenerateButton(true);
      setShowChatLoader(true);
      setLastDisplayMessage("");
      setDisplayLastCitations([]);

      let finalShortName = conversationShortName;
      if (!finalShortName) {
        finalShortName = updateConversationShortName(skill, inputText);
      }

      const userMessage = {
        text: inputText,
        type: "user",
        imageURL: AppImages.profilePic,
        citations: [],
        chatType: isMKSChat,
        skill: skill?.Name,
        isErrorOccured: false,
      };

      const date = new Date(); // Current local time
      const userUtcDate = date.toISOString();

      userMessageDummy = {
        conversationId: conversationId,
        conversationShortName: finalShortName,
        conversationDateTime: userUtcDate,
        user_Id: userId,
        skillId: skill?.Id,
        citations: [],
        chatText: inputText,
        role: "User",
        isFailed: false,
        lat: location.lat,
        long: location.long,
        userEmail: userEmail,
        ModelName: selectedModelName,
      };

      setMessages((prev) => [...prev, userMessage]);

      let formatedInputText = inputText
        .replace(/\n/g, "\\n") // Escape newlines
        .replace(/\r/g, "\\r") // Escape carriage returns
        .replace(/\\/g, "\\\\")
        .replace(/^"|"$/g, "");
      formatedInputText = formatedInputText.replace(
        /"([^"]*?)"(?=\s|[:,}])/g,
        '\\"$1\\"'
      );
      let userMessageData = skill.userMessage.replace(
        "$Message",
        `"${formatedInputText}"`
      );

      let lastMessageCount =
        skill.lastMessageCount == null ? 0 : skill.lastMessageCount;

      let parsedUserMessageData = JSON.parse(userMessageData);

      const finalRequestBody = [];
      let isStreamAPI = true;

      let oldgenericAPIUserMessages = [...genericAPIUserMessages];
      if (lastMessageCount > 0) {
        let previousSentMessages = filterTopMessagesV2(
          genericAPIUserMessages,
          parseInt(lastMessageCount),
          messages,
          skill.AssistantMessageFormat,
          skill.userMessage
        );

        if (previousSentMessages.length > 0) {
          previousSentMessages.forEach((msg) => {
            finalRequestBody.push(msg);

            if (genericAPIUserMessages.length === 0) {
              oldgenericAPIUserMessages.push(msg);
            }
          });
        }
      }
      finalRequestBody.push(parsedUserMessageData);
      oldgenericAPIUserMessages.push(parsedUserMessageData);
      let userMessageModel2 = {
        skill_store_id: skill.Id,
        ModelId: selectedModelId === "0" || selectedModelId === 0 ? "default" : selectedModelId,
        ModelName: selectedModelName,
        user_messages: finalRequestBody,
      };

      isStreamAPI = false; // Default to false since we're using a custom object
      userMessageModel2 = JSON.stringify(userMessageModel2);

      const aiResponse = {
        text: "loader",
        type: "reply",
        imageURL: AppImages.chatAIIcon,
        citations: [],
        chatType: isMKSChat,
        skill: skill?.Name,
      };

      setMessages((prev) => [...prev, aiResponse]);

      let response = "";
      let result = {};
      try {
        const wrapperUrl = skill?.IsUsingWrapperAPIURL
          ? skill?.WrapperAPIURL
          : process.env.REACT_APP_CHAT_SKILL_WRAPPER_URL;

        const responseA = await fetch(wrapperUrl, {
          method: skill.method,
          headers: {
            Authorization: "Bearer " + localStorage.getItem("token"),
            "Content-Type": "application/json",
          },
          body: userMessageModel2,
        });

        if (!responseA.ok || !responseA.body) {
          if (
            responseA.status === 500 &&
            isGivenTokenExpired(localStorage.getItem("token"))
          ) {
            showMessage(
              "Session timed out, you will be redirected to login screen.",
              -2
            );
            setTimeout(() => {
              setIsUserLoggedOut(true);
              navigate("/login");
            }, 3000);
            return;
          }

          if (
            responseA.status === 500 ||
            responseA.status === 400 ||
            responseA.status === 429
          ) {
            const responseString = await responseA?.text();
            const contains429 =
              responseString.includes("429") ||
              responseString.includes("RateLimitError");
            if (contains429) {
              showMessage(
                "The system has reached its allowed usage quota (tokens per minute).Please wait a few minutes and try again. If you need immediate assistance, contact the support team.",
                -2
              );
              resetControls();
              userMessageDummy.isFailed = true;
              saveHistory(userMessageDummy);
              return;
            } else {
              handleExceptionAndMessages();
              userMessageDummy.isFailed = true;
              saveHistory(userMessageDummy);
              return;
            }
          }
          handleExceptionAndMessages();
          userMessageDummy.isFailed = true;
          saveHistory(userMessageDummy);
          return;
        }
        const reader = responseA.body.getReader();
        const decoder = new TextDecoder("utf-8");
        const loopRunner = true;
        let citations = [];
        let runningText = "";
        let tokenUsage = null; // NEW: will hold the final token_usage object once we see it

        while (loopRunner) {
          try {
            const { value, done } = await reader.read();
            if (done) {
              break;
            }
            let decodedChunk = decoder.decode(value, { stream: true });
            const objects = decodedChunk.split("\n");
            objects.forEach((obj) => {
              try {
                if (obj !== "" && obj !== "{}") {
                  runningText += obj;
                  result = JSON.parse(runningText);
                  if (result.choices?.length > 0) {
                    result.choices[0].messages.forEach((msg) => {
                      msg.id = result.id;
                      msg.date = new Date().toISOString();
                    });
                    if (
                      result.choices[0].messages?.some(
                        (m) => m.role === ASSISTANT
                      )
                    ) {
                    }
                    result.choices[0].messages.forEach((resultObj) => {
                      if (resultObj.role === ASSISTANT) {
                        response = response + resultObj.content;
                      }
                      if (resultObj.role === TOOL) {
                        if (
                          resultObj?.role &&
                          resultObj?.role === "tool" &&
                          resultObj?.content !== ""
                        ) {
                          try {
                            let contents = JSON.parse(resultObj.content);
                            if (contents?.citations) {
                              citations = contents.citations;
                            }
                          } catch {
                            return [];
                          }
                        }
                      }
                    });
                  }
                  if (result.token_usage) {
                    // NEW: final SSE chunk carrying usage + cost info
                    tokenUsage = result.token_usage;
                  }
                  if (result.error) {
                    handleApiError(new BOTAPIError());
                  }
                  runningText = "";
                }
              } catch (e) {
                if (!(e instanceof SyntaxError)) {
                  handleApiError(new BOTAPIError());
                }
              }
            });
          } catch (readError) { }
          setShowChatLoader(false);
        }

        let followupText = [];
        if (showFollowUpQuestions && disableFolloupButton === false) {
          const result = extractAndRemoveFollowUps(response);
          response = result.modifiedText;
          followupText = result.followUpQuestions;
        } else if (disableFolloupButton) {
          const result = extractAndRemoveFollowUps(response);
          response = result.modifiedText;
        }
        if (response === "") {
          response = " ";
        }
        saveHistory(userMessageDummy);
        setIsReplyFromBot(true);
        const botMessage = {
          text: response,
          type: "reply",
          imageURL: AppImages.chatAIIcon,
          citations: citations,
          chatType: isMKSChat,
          skill: skill?.Name,
          followupQuestion: followupText,
        };
        const date = new Date(); // Current local time
        const replyUtcDate = date.toISOString();

        const botMessageDummy = {
          conversationId: conversationId,
          conversationShortName: finalShortName,
          conversationDateTime: replyUtcDate,
          user_Id: userId,
          skillId: skill?.Id,
          citations: citations,
          chatText: response,
          role: "reply",
          isFailed: false,
          lat: location.lat,
          long: location.long,
          userEmail: userEmail,
          ModelName: selectedModelName,
          inputTokens: tokenUsage?.prompt_tokens ?? null,
          outputTokens: tokenUsage?.completion_tokens ?? null,
          totalTokens: tokenUsage?.total_tokens ?? null,
          inputCostUsd: tokenUsage?.input_cost_usd ?? null,
          outputCostUsd: tokenUsage?.output_cost_usd ?? null,
          totalCostUsd: tokenUsage?.total_cost_usd ?? null,
        };
        saveHistory(botMessageDummy);

        let assistantMessageModel = skill.AssistantMessageFormat.replace(
          "$replyMsg",
          `"${response}"`
        );

        let assistantMessage = {};
        try {
          assistantMessage = JSON.parse(assistantMessageModel);
        } catch (error) {
          assistantMessage = JSON.parse(
            skill.AssistantMessageFormat.replace("$replyMsg", `"$"`)
          );
          if (assistantMessage.content[0].type === undefined) {
            assistantMessage.content = response;
            assistantMessage.role = "assistant";
          } else {
            assistantMessage.content[0].text = response;
            assistantMessage.role = "assistant";
          }
        }

        oldgenericAPIUserMessages.push(assistantMessage);
        setGenericAPIUserMessages([...oldgenericAPIUserMessages]);

        //setMessageToSession(botMessage);
        setMessages((prev) => [
          ...prev.filter((p) => p.text !== "loader"),
          botMessage,
        ]);

        setMessageToSessionDummy(botMessageDummy);
        setMessagesDummy((prev) => [
          ...prev.filter((p) => p.text !== "loader"),
          botMessageDummy,
        ]);

        setLastDisplayMessage(response);
        setDisplayLastCitations(citations);
      } catch (error) {
        handleExceptionAndMessages();
        userMessageDummy.isFailed = true;
        saveHistory(userMessageDummy);
      }
    } catch (ex) {
      console.log(ex);
      handleExceptionAndMessages();
      userMessageDummy.isFailed = true;
      saveHistory(userMessageDummy);
    }
  };

  useEffect(() => {
    if (!isRunning && init) {
      messages.map((msg, index) => {
        if (messages.length - 1 === index) {
          msg.text = lastDisplayMessage;
          msg.citations = displayLastCitations;
        }
        return msg;
      });
      setMessages(messages);
      let localMessage = localStorage.getItem("messages") || "";
      if (localMessage === "") localMessage = [];
      else localMessage = JSON.parse(localMessage);

      localMessage.map((msg, index) => {
        if (msg.chatType === true && msg.type !== "user") {
          if (localMessage.length - 1 === index) {
            msg.text = lastDisplayMessage;
          }
        }
        if (msg.chatType === false && msg.type !== "user") {
          if (localMessage.length - 1 === index) {
            msg.text = lastDisplayMessage;
          }
        }
        return msg;
      });
      localStorage.setItem("messages", JSON.stringify(localMessage));
    }
  }, [isRunning]);

  const handleMksAIWrapperResponse = async (inputText) => {
    try {
      if (!inputText?.trim()) {
        return;
      }

      if (mksDefaultConfiguration !== undefined) {
        setIsSkillProcessing(false);
        setIsMKSProcessing(true);
        setShowChatLoader(true);
        setLastDisplayMessage("");
        setDisplayLastCitations([]);
        setDisableStopGenerateButton(true);
        setDisableRegenerateButton(true);
        let requestBody = mksDefaultConfiguration.body;
        const userMessage = {
          text: inputText,
          type: "user",
          imageURL: AppImages.profilePic,
          chatType: isMKSChat,
          skill: "",
        };
        setMessageToSession(userMessage);
        setMessages((prev) => [...prev, userMessage]);

        const aiResponse = {
          text: "loader",
          type: "reply",
          imageURL: AppImages.chatAIIcon,
          chatType: isMKSChat,
          skill: "",
        };
        setMessages((prev) => [...prev, aiResponse]);
        let updatedText = removeSpecialCharacters(inputText);
        const formatedInputText = updatedText
          .replace(/\n/g, "\\n") // Escape newlines
          .replace(/\r/g, "\\r") // Escape carriage returns
          .replace(/\\/g, "\\\\")
          .replace(/^"|"$/g, "");

        let userMessageModel = mksDefaultConfiguration.userMessage.replace(
          "$Message",
          `"${formatedInputText}"`
        );

        let lastMessageCount = mksDefaultConfiguration.lastMessageCount;
        // let parsedUserMessageModel = JSON.parse(userMessageModel);

        let oldmksUserMessages = [...mksUserMessages];
        const finalRequestBody = [];
        if (lastMessageCount > 0) {
          let previousSentMessages = filterTopMessagesV2(
            genericAPIUserMessages,
            parseInt(lastMessageCount),
            messages,
            mksDefaultConfiguration.assistantMessage,
            mksDefaultConfiguration.userMessage
          );

          if (previousSentMessages.length > 0) {
            previousSentMessages.forEach((msg) => {
              finalRequestBody.push(msg);
              if (mksUserMessages.length === 0) {
                oldmksUserMessages.push(msg);
              }
            });
          }
        }
        finalRequestBody.push(JSON.parse(userMessageModel));
        let finalString = JSON.stringify(finalRequestBody);
        finalString = finalString.substring(1, finalString.length - 1);
        requestBody = requestBody.replace("$UserMessage", finalString);

        oldmksUserMessages.push(JSON.parse(userMessageModel));

        mksDefaultConfiguration.headers.openai_api_key =
          mksDefaultConfiguration.headers["api-key"];
        mksDefaultConfiguration.headers.openai_endpoint =
          mksDefaultConfiguration.url;

        let response = "";
        setIsMKSProcessing(true);
        try {
          const responseA = await fetch(
            process.env.REACT_APP_CHAT_SKILL_WRAPPER_URL,
            {
              method: mksDefaultConfiguration.method,
              headers: mksDefaultConfiguration.headers,
              body: json.stringify(requestBody),
            }
          );

          if (!responseA.ok || !responseA.body) {
            handleApiError(new BOTAPIError("MKS Chat"));
            handleExceptionResponse();
            return;
          }
          const reader = responseA.body.getReader();
          const decoder = new TextDecoder();
          const loopRunner = true;
          let runningText = "";
          while (loopRunner) {
            try {
              setIsMKSProcessing(true);
              const { done, value } = await reader.read();
              if (done) break;

              var text = new TextDecoder("utf-8").decode(value, {
                stream: true,
              });
              const objects = text.split("\n");
              objects.forEach((obj) => {
                try {
                  if (obj !== "" && obj !== "{}") {
                    runningText += obj;
                    let result = JSON.parse(runningText);
                    if (result.choices?.length > 0) {
                      result.choices[0].messages.forEach((msg) => {
                        if (msg.role === "ASSISTANT") {
                          response += msg.content;
                        }
                      });
                    }
                    runningText = "";
                  }
                } catch (e) { }
              });
              setIsMKSProcessing(false);
            } catch (readError) {
              break; // Exit the loop if reading fails
            }
          }
        } catch (fetchError) {
          handleExceptionAndMessages();
          return;
        }

        const botMessage = {
          text: response,
          type: "reply",
          imageURL: AppImages.chatAIIcon,
          citations: [],
          chatType: isMKSChat,
          skill: "",
        };

        let assistantMessageModel =
          mksDefaultConfiguration.assistantMessage.replace(
            "$replyMsg",
            `"${response}"`
          );
        let assistantMessage = {};
        try {
          assistantMessage = JSON.parse(assistantMessageModel);
        } catch (error) {
          assistantMessage = JSON.parse(
            mksDefaultConfiguration.assistantMessage.replace("$replyMsg", `"$"`)
          );
          if (assistantMessage.content[0].type === undefined) {
            assistantMessage.content = response;
            assistantMessage.role = "assistant";
          } else {
            assistantMessage.content[0].text = response;
            assistantMessage.role = "assistant";
          }
        }

        mksUserMessages.push(assistantMessage);
        setMksUserMessages([...mksUserMessages]);
        setMessageToSession(botMessage);
        setMessages((prev) => [
          ...prev.filter((p) => p.text !== "loader"),
          botMessage,
        ]);
        setShowChatLoader(false);
        setLastDisplayMessage("");
        typeText(response, []);
      }
    } catch {
      handleExceptionAndMessages();
    }
  };

  const handleMksAIResponse = async (inputText) => {
    try {
      if (!inputText?.trim()) {
        return;
      }

      if (mksDefaultConfiguration !== undefined) {
        setIsSkillProcessing(false);
        setIsMKSProcessing(true);
        setShowChatLoader(true);
        setLastDisplayMessage("");
        setDisplayLastCitations([]);
        setDisableStopGenerateButton(true);
        setDisableRegenerateButton(true);
        let requestBody = mksDefaultConfiguration.body;
        const userMessage = {
          text: inputText,
          type: "user",
          imageURL: AppImages.profilePic,
          chatType: isMKSChat,
          skill: "",
        };
        setMessageToSession(userMessage);
        setMessages((prev) => [...prev, userMessage]);

        const aiResponse = {
          text: "loader",
          type: "reply",
          imageURL: AppImages.chatAIIcon,
          chatType: isMKSChat,
          skill: "",
        };
        setMessages((prev) => [...prev, aiResponse]);
        let updatedText = removeSpecialCharacters(inputText);
        const formatedInputText = updatedText
          .replace(/\n/g, "\\n") // Escape newlines
          .replace(/\r/g, "\\r") // Escape carriage returns
          .replace(/\\/g, "\\\\")
          .replace(/^"|"$/g, "");

        let userMessageModel = mksDefaultConfiguration.userMessage.replace(
          "$Message",
          `"${formatedInputText}"`
        );

        let lastMessageCount = mksDefaultConfiguration.lastMessageCount;
        // let parsedUserMessageModel = JSON.parse(userMessageModel);

        let oldmksUserMessages = [...mksUserMessages];
        const finalRequestBody = [];
        if (lastMessageCount > 0) {
          let previousSentMessages = filterTopMessagesV2(
            genericAPIUserMessages,
            parseInt(lastMessageCount),
            messages,
            mksDefaultConfiguration.assistantMessage,
            mksDefaultConfiguration.userMessage
          );

          if (previousSentMessages.length > 0) {
            previousSentMessages.forEach((msg) => {
              finalRequestBody.push(msg);
              if (mksUserMessages.length === 0) {
                oldmksUserMessages.push(msg);
              }
            });
          }
        }
        finalRequestBody.push(JSON.parse(userMessageModel));
        let finalString = JSON.stringify(finalRequestBody);
        finalString = finalString.substring(1, finalString.length - 1);
        requestBody = requestBody.replace("$UserMessage", finalString);

        oldmksUserMessages.push(JSON.parse(userMessageModel));

        let response = "";
        setIsMKSProcessing(true);
        try {
          const responseA = await fetch(
            removeTrailingSlash(mksDefaultConfiguration.url),
            {
              method: mksDefaultConfiguration.method,
              headers: mksDefaultConfiguration.headers,
              body: requestBody,
            }
          );

          if (!responseA.ok || !responseA.body) {
            handleApiError(new BOTAPIError("MKS Chat"));
            handleExceptionResponse();
            return;
          }
          const reader = responseA.body.getReader();
          const decoder = new TextDecoder();
          const loopRunner = true;
          while (loopRunner) {
            try {
              setIsMKSProcessing(true);
              // Read each chunk in the stream
              const { value, done } = await reader.read();
              if (done) {
                break;
              }

              // Decode the chunk and handle potential errors
              const decodedChunk = decoder.decode(value, { stream: true });
              let datas;

              try {
                // Process the decoded chunk
                datas = JSON.parse(
                  JSON.stringify(
                    decodedChunk
                      .replace("data: ", "")
                      .split("\n\ndata:")
                      .slice(0, -1)
                  )
                );
              } catch (decodeError) {
                console.log("Error processing decoded chunk:", decodeError);
                continue; // Skip this chunk if JSON parsing fails
              }

              // Process each item in the parsed data
              let counter = 0;
              datas.forEach((da) => {
                let jsonArray = null;
                try {
                  jsonArray = JSON.parse(da);
                  if (jsonArray.choices.length > 0) {
                    const text = jsonArray.choices[0].delta?.content || "";
                    if (counter < 2 && (text.match(/\n/) || []).length) {
                      return;
                    }
                    response = response + text;
                    setIsTyping(true);
                    counter++;
                  }
                } catch (parseError) {
                  console.log(
                    "Error parsing JSON array item:",
                    parseError,
                    " Raw Item ",
                    da
                  );
                }
              });
            } catch (readError) {
              break; // Exit the loop if reading fails
            }
          }
        } catch (fetchError) {
          handleExceptionAndMessages();
          return;
        }

        const botMessage = {
          text: response,
          type: "reply",
          imageURL: AppImages.chatAIIcon,
          citations: [],
          chatType: isMKSChat,
          skill: "",
        };

        let assistantMessageModel =
          mksDefaultConfiguration.assistantMessage.replace(
            "$replyMsg",
            `"${response}"`
          );
        let assistantMessage = {};
        try {
          assistantMessage = JSON.parse(assistantMessageModel);
        } catch (error) {
          assistantMessage = JSON.parse(
            mksDefaultConfiguration.assistantMessage.replace("$replyMsg", `"$"`)
          );
          if (assistantMessage.content[0].type === undefined) {
            assistantMessage.content = response;
            assistantMessage.role = "assistant";
          } else {
            assistantMessage.content[0].text = response;
            assistantMessage.role = "assistant";
          }
        }

        mksUserMessages.push(assistantMessage);
        setMksUserMessages([...mksUserMessages]);
        setMessageToSession(botMessage);
        setMessages((prev) => [
          ...prev.filter((p) => p.text !== "loader"),
          botMessage,
        ]);
        setShowChatLoader(false);
        setLastDisplayMessage("");
        typeText(response, []);
      }
    } catch {
      handleExceptionAndMessages();
    }
  };

  const removeTrailingSlash = (url) => {
    return url.endsWith("\\") ? url.slice(0, -1) : url;
  };

  const typeText = (replyText, citations) => {
    setCurrentMessage(replyText);
    setResumeCitations(citations);
    let index = 0;
    if (!isRunning) {
      setIsRunning(true);

      intervalRef.current = setInterval(() => {
        setLastDisplayMessage(
          (lastDisplayMessage) => lastDisplayMessage + replyText[index - 1]
        );
        setDisableStopGenerateButton(false);
        index++;
        setRunningIndex(index);
        if (isMKSChat) {
          setIsMKSProcessing(true);
          setIsSkillProcessing(false);
        } else {
          setIsMKSProcessing(false);
          setIsSkillProcessing(true);
        }

        if (index >= replyText.length) {
          clearInterval(intervalRef.current);
          setIsTyping(false);
          setIsRunning(false);
          setRunningIndex(replyText.length - 1);
          setDisplayLastCitations(citations);
          setDisableStopGenerateButton(true);
          setDisableRegenerateButton(true);
        }
      }, process.env.REACT_DEFAULT_TIME_INTERVAL);
    }
  };

  const handleLinkClicked = (value) => {
    setIsLinkClicked(value);
  };
  const pauseTimer = () => {
    if (isRunning) {
      setIsRunning(false);
      clearInterval(intervalRef.current);
      setIsMKSProcessing(false);
      setIsSkillProcessing(false);
      setDisableRegenerateButton(false);
      setDisableStopGenerateButton(true);
      setInit(true);
    }
  };

  const resumeResponse = () => {
    setDisableStopGenerateButton(false);
    setDisableRegenerateButton(true);
    let index = runningIndex;
    if (!isMKSChat) {
      setIsSkillProcessing(true);
      setIsMKSProcessing(false);
    } else {
      setIsSkillProcessing(false);
      setIsMKSProcessing(true);
    }

    if (
      !isRunning &&
      currentMessage &&
      lastDisplayMessage?.length < currentMessage?.length
    ) {
      setIsRunning(true);
      setDisableStopGenerateButton(false);

      intervalRef.current = setInterval(() => {
        if (currentMessage[index - 1] !== undefined) {
          setLastDisplayMessage((prev) => {
            if (prev.length < currentMessage.length) {
              return prev + currentMessage[index - 1];
            }
            return prev;
          });
          index++;
          setRunningIndex(index);
        }

        if (index >= currentMessage.length) {
          clearInterval(intervalRef.current);
          setIsTyping(false);
          setIsRunning(false);
          setDisableStopGenerateButton(true);
          setDisableRegenerateButton(true);
          setDisplayLastCitations(resumeCitations);
        }
      }, process.env.REACT_DEFAULT_TIME_INTERVAL);
    }
  };

  const getWelcomeMessage = () => {
    if (messages?.length === 0) {
      if (isMKSChat) {
        return (
          <>
            <h1 className="h1 color-span medium-font">Welcome to MKS Chat</h1>
            <p className="subtext">
              Get more contextual answers to problems you are solving with a
              conversational assistant tailored to specialized domains and
              functional areas.
            </p>
          </>
        );
      } else {
        return (
          <>
            <h1 className="h1 color-span medium-font">
              Welcome to{" "}
              {!skill?.Name || defaultSkillWelMessage
                ? "Skills Chat"
                : /\bchat\s*$/i.test(skill?.Name.trim())
                  ? skill?.Name
                  : `${skill?.Name.trim()} Chat`}
            </h1>
            <p className="subtext"><b>You are interacting with an AI assistant, not a human.</b>  Responses are AI-generated and may be inaccurate, incomplete, or outdated. Verify any information before relying on it for business decisions.</p>
            <p className="subtext">
              {skill?.ShortDescription === "" ||
                skill?.ShortDescription === undefined ||
                skill?.ShortDescription === null ||
                defaultSkillWelMessage
                ? ""
                // ? "Get more contextual answers to problems you are solving with a conversational assistant tailored to specialized domains and functional areas."
                : skill?.ShortDescription}
            </p>
          </>
        );
      }
    }
  };

  return (
    <>
      <div
        className={`chatbox ${isLinkClicked ? "linkclass-clicked" : ""} ${isAdditiveExpanded ? "chat-sidebar" : ""
          }`}
      >
        <div className="userintro">
          <p>Hi {fullName} </p>
          <div className="wavy-hand"></div>
        </div>

        {getWelcomeMessage()}
        <>
          {isFileTypeChat && (
            <FileChatbot
              showChatLoader={showChatLoader}
              messages={messages}
              initials={initials}
              isFileTypeChat={isFileTypeChat}
              lastDisplayMessage={lastDisplayFileMessage}
              uploadedFileDetails={uploadedFileDetails}
              isTyping={isTyping}
              blackBoxAdditives={blackBoxAdditives}
              isBlackBoxAdded={isBlackBoxAdded}
              setIsMKSProcessing={setIsMKSProcessing}
              setIsSkillProcessing={setIsSkillProcessing}
              setIsMessageTyping={setIsMessageTyping}
              isMessageTyping={isMessageTyping}
              isTranslateAdded={isTranslateAdded}
            ></FileChatbot>
          )}
          {!isFileTypeChat && (
            <TextChatbot
              showChatLoader={showChatLoader}
              setIsReplyFromBot={setIsReplyFromBot}
              isReplyFromBot={isReplyFromBot}
              messages={messages}
              initials={initials}
              isFileTypeChat={isFileTypeChat}
              displayLastCitations={displayLastCitations}
              lastDisplayMessage={lastDisplayMessage}
              setOpenPdfViewer={setOpenPdfViewer}
              lastImageArray={lastImageArray}
              setSelectedCitation={setSelectedCitation}
              isTyping={isTyping}
              setIsMKSProcessing={setIsMKSProcessing}
              setIsSkillProcessing={setIsSkillProcessing}
              setIsMessageTyping={setIsMessageTyping}
              isMessageTyping={isMessageTyping}
              setPdfClass={setPdfClass}
              pdfClass={pdfClass}
              showFollowupQuestion={showFollowupQuestion}
              disableFolloupButton={disableFolloupButton}
              handleSendMessage={handleAIGenericResponse}
              isHybridChat={isHybridChat}
              onLinkClick={handleLinkClicked}
              IsLinkClicked={isLinkClicked}
              skill={skill}
              isAllowedMessageStreaming={isAllowedMessageStreaming}
              setTypingMessage={setTypingMessage}
            ></TextChatbot>
          )}
        </>
        <div ref={bottomPanelRef}></div>
      </div>

      <ChatPrompt
        setInit={setInit}
        isMKSChat={isMKSChat}
        navigateFromHome={navigateFromHome}
        chatMessage={chatMessage}
        promptText={promptText}
        setSkill={setSkill}
        skill={skill}
        handleSendMessage={handleAIGenericResponse}
        fileName={fileName}
        setMessages={setMessages}
        setIsSkillChat={setIsSkillChat}
        setIsFileTypeChat={setIsFileTypeChat}
        isFileTypeChat={isFileTypeChat}
        setDefaultSkillWelMessage={setDefaultSkillWelMessage}
        setUploadedFilesFromChat={setUploadedFilesFromChat}
        uploadedFilesFromChat={uploadedFilesFromChat}
        clearUploadedFile={clearUploadedFile}
        setResetAdditives={setResetAdditives}
        setGenericAPIUserMessages={setGenericAPIUserMessages}
        isMKSProcessing={isMKSProcessing}
        setIsMKSProcessing={setIsMKSProcessing}
        isSkillProcessing={isSkillProcessing}
        setIsSkillProcessing={setIsSkillProcessing}
        setIsMessageTyping={setIsMessageTyping}
        isMessageTyping={isMessageTyping}
        setClearUploadedFile={setClearUploadedFile}
        selectedAdditives={selectedAdditives}
        setOpenPdfViewer={setOpenPdfViewer}
        setIsHybridChat={setIsHybridChat}
        isHybridChat={isHybridChat}
        isLinkClicked={isLinkClicked}
        setPdfClass={setPdfClass}
        onLinkClick={setIsLinkClicked}
        isAdditiveExpanded={isAdditiveExpanded}
        matchedSkill={matchedSkill}
      />

      <ChatHistory
        isSkillChat={!isMKSChat}
        isMKSChat={isMKSChat}
        isFileType={isFileTypeChat}
        setSelectedAdditives={setSelectedAdditives}
        setIsClearChat={setIsClearChat}
        isChatVisible={isChatVisible}
        openPdfViewer={openPdfViewer}
        setOpenPdfViewer={setOpenPdfViewer}
        selectedCitation={selectedCitation}
        resetAdditives={resetAdditives}
        setResetAdditives={setResetAdditives}
        selectedAdditives={selectedAdditives}
        isMKSProcessing={isMKSProcessing}
        isSkillProcessing={isSkillProcessing}
        isMessageTyping={isMessageTyping}
        skill={skill}
        pdfClass={pdfClass}
        setPdfClass={setPdfClass}
        conversationShortName={conversationShortName}
        handleChatHistoryRowClick={handleChatHistoryRowClick}
        onLinkClick={setIsLinkClicked}
        setIsAdditiveExpanded={setIsAdditiveExpanded}
        isAdditiveExpanded={isAdditiveExpanded}
        expandChecks={expandChecks}
        setExpandChecks={setExpandChecks}
      />
    </>
  );
};

export default ChatBox;
